var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-action-sheet',{attrs:{"actions":_vm.actions,"cancel-text":"取消","close-on-click-action":""},on:{"cancel":_vm.onCancel,"select":_vm.onSelect},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }